import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateContactPanelTaskList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 225,
	height: 225,
	viewBox: "0 0 225 225",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M121.241 221.491C177.743 221.491 223.548 175.686 223.548 119.184C223.548 62.6814 177.743 16.8771 121.241 16.8771C64.7384 16.8771 18.9341 62.6814 18.9341 119.184C18.9341 175.686 64.7384 221.491 121.241 221.491Z",
			fill: "#EEF5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.441 21.9545C141.664 21.1337 145.767 23.901 146.587 28.1234L171.07 154.074C171.89 158.296 169.123 162.399 164.9 163.219L79.7852 179.764C75.5628 180.585 71.46 177.818 70.6392 173.595L46.157 47.645C45.3362 43.4226 48.1037 39.3199 52.3261 38.4991L137.441 21.9545ZM135.852 13.7799L50.7372 30.3246C41.9933 32.0242 36.2828 40.4903 37.9824 49.234L62.4646 175.184C64.1642 183.928 72.6304 189.638 81.3742 187.939L166.489 171.394C175.233 169.694 180.944 161.228 179.244 152.485L154.762 26.5344C153.062 17.7908 144.596 12.0803 135.852 13.7799Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.441 21.9544C141.664 21.1336 145.766 23.9008 146.587 28.1233L171.069 154.073C171.89 158.296 169.123 162.399 164.9 163.219L79.7851 179.764C75.5627 180.585 71.4598 177.817 70.6391 173.595L46.1569 47.6449C45.3361 43.4225 48.1036 39.3198 52.326 38.499L137.441 21.9544Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.9912 106.819L81.2531 109.019L85.889 102.146",
			stroke: "white",
			strokeWidth: 2.36691,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M176.489 149.857C192.908 149.857 206.218 136.547 206.218 120.128C206.218 103.709 192.908 90.3991 176.489 90.3991C160.07 90.3991 146.76 103.709 146.76 120.128C146.76 136.547 160.07 149.857 176.489 149.857Z",
			fill: "#76AFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.4164 14.7963C92.7104 14.7963 94.5701 12.9366 94.5701 10.6426C94.5701 8.34856 92.7104 6.48889 90.4164 6.48889C88.1224 6.48889 86.2627 8.34856 86.2627 10.6426C86.2627 12.9366 88.1224 14.7963 90.4164 14.7963Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.4607 19.6082L105.782 14.1242C114.856 12.3673 123.649 18.3074 125.406 27.381L125.693 28.8648C126.017 30.5385 124.921 32.1604 123.248 32.4845L68.1109 43.1608C66.4372 43.4849 64.8152 42.3891 64.4912 40.7154L64.2039 39.2317C62.4469 30.1581 68.3871 21.3651 77.4607 19.6082Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.0726 3.70107C94.7258 2.60642 100.204 6.30742 101.299 11.9607L102.401 17.6505L81.9147 21.6173L80.813 15.9274C79.7183 10.2742 83.4193 4.79573 89.0726 3.70107Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4502_127086",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 63,
			y: 13,
			width: 63,
			height: 31,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M77.4607 19.6074L105.782 14.1235C114.856 12.3665 123.649 18.3067 125.406 27.3803L125.693 28.8641C126.017 30.5378 124.921 32.1597 123.248 32.4838L68.1109 43.16C66.4372 43.4841 64.8152 42.3884 64.4912 40.7147L64.2039 39.2309C62.4469 30.1574 68.3871 21.3644 77.4607 19.6074Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4502_127086)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M129.184 26.6864L60.4399 39.9974L61.6914 46.4605L130.435 33.1495L129.184 26.6864Z",
				fill: "#FFBA00"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.688 119.59L172.284 127.187L188.29 111.181",
			stroke: "#EEF5FF",
			strokeWidth: 5.17014,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.0144 102.375C96.3744 102.464 95.9416 103.085 96.0874 103.715C97.6262 110.36 104.015 114.845 110.899 113.885C117.784 112.925 122.7 106.862 122.362 100.05C122.33 99.4045 121.744 98.9257 121.104 99.015L97.0144 102.375Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.596 108.83C116.893 106.833 113.44 105.847 109.848 106.348C106.256 106.849 103.205 108.743 101.151 111.403C103.854 113.4 107.307 114.386 110.899 113.885C114.491 113.384 117.542 111.491 119.596 108.83Z",
			fill: "#E0EEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.6094 87.1814C96.319 85.1 94.3964 83.6482 92.3152 83.9385C90.2337 84.2289 88.7818 86.1513 89.0721 88.2328C89.3624 90.314 91.2851 91.7659 93.3663 91.4756C95.4478 91.1853 96.8997 89.2628 96.6094 87.1814Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.857 83.1239C124.567 81.0425 122.644 79.5907 120.563 79.881C118.482 80.1714 117.03 82.0938 117.32 84.1753C117.61 86.2565 119.533 87.7084 121.614 87.4181C123.696 87.1278 125.148 85.2053 124.857 83.1239Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4404 37.5132H24.2138",
			stroke: "#DFEDFD",
			strokeWidth: 3.77748,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.731 17.9585L27.9346 24.1622",
			stroke: "#DFEDFD",
			strokeWidth: 3.77748,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.1763 11.6678V20.4412",
			stroke: "#DFEDFD",
			strokeWidth: 3.77748,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.653 71.7243C198.672 71.7243 200.307 70.0884 200.307 68.0704C200.307 66.0523 198.672 64.4164 196.653 64.4164C194.635 64.4164 193 66.0523 193 68.0704C193 70.0884 194.635 71.7243 196.653 71.7243Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.8328 209.127C29.2855 209.127 32.8952 205.517 32.8952 201.064C32.8952 196.612 29.2855 193.002 24.8328 193.002C20.3801 193.002 16.7705 196.612 16.7705 201.064C16.7705 205.517 20.3801 209.127 24.8328 209.127Z",
			fill: "#E0EEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5843 70.2562C19.019 70.2562 20.9928 68.2824 20.9928 65.8477C20.9928 63.413 19.019 61.4392 16.5843 61.4392C14.1495 61.4392 12.1758 63.413 12.1758 65.8477C12.1758 68.2824 14.1495 70.2562 16.5843 70.2562Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M186.014 20.7693C189.872 20.7693 192.999 17.6419 192.999 13.7841C192.999 9.92631 189.872 6.79895 186.014 6.79895C182.156 6.79895 179.029 9.92631 179.029 13.7841C179.029 17.6419 182.156 20.7693 186.014 20.7693Z",
			fill: "#E0EEFE"
		})
	]
});
export default SvgEmptyStateContactPanelTaskList;
